const MAP_CONFIG = {
  provider: process.env.REACT_APP_MAP_PROVIDER || 'leaflet',
  geocodingProvider: process.env.REACT_APP_GEOCODER_PROVIDER || 'nominatim',
  defaultCenter: [56.1304, -106.3468],
  defaultZoom: 4,
  maxZoom: 18,
  minZoom: 2,
  tileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  tileAttribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  maxGeocodePerBatch: 60,
  geocodeDelayMs: 120,
};

export default MAP_CONFIG;
